import { I18nSchema } from "./I18nSchema";
import { I18nRussian } from "./I18nRussian";

export const I18nUzbek: I18nSchema = {
  ...I18nRussian,
  //Navbar
  TITTLE_NAVBAR_MENU_ORDERS: "Buyurtmalar",
  TITTLE_NAVBAR_MENU_ROUTES: "Marshrutlar",
  TITTLE_NAVBAR_MENU_ROUTES_SETTING: "Marshrutlar sozlamasi",
  TITTLE_NAVBAR_MENU_ANALYTICS: "Analitika",
  TITTLE_NAVBAR_MENU_ANALYTICS_MILEAGE: "Bosib o'tkan masofa TC",
  TITTLE_NAVBAR_MENU_ANALYTICS_TO_GMC: "TO va GMS",
  TITTLE_NAVBAR_MENU_ANALYTICS_TIME_SLOTS: "Vaqtlar oralig'i",
  TITTLE_NAVBAR_MENU_SETTING: "Sozlamalar",
  TITTLE_NAVBAR_MENU_SETTING_MOBILE_CLIENT: "Transport",
  TITTLE_NAVBAR_MENU_SETTING_DRIVERS: "Haydovchilar",
  TITTLE_NAVBAR_MENU_SETTING_CAR_PARK: "Avtopark",
  TITTLE_NAVBAR_MENU_SETTING_CLIENT: "Mijozlar",
  TITTLE_HEADER_SEARCH: "Qidiruv...",
  TITLE_PAGINATION_TABLE_TOTAL_COLUMN: "Jami",
  PAGINATION_OF_TITLE: "dan",

  //Filters
  TITTLE_FILTER_SEARCH: "Buyurtmalar qidiruvi",
  TITTLE_FILTER_DATA: "Malumotlar filtri",
  TITTLE_FILTER: "Filterlar",
  TITTLE_FILTER_COLS: "Kolonkalar",
  TITTLE_FILTER_INTERVAL: "Sana intervali",
  TITTLE_SELECT_PLACEHOLDER: "Tanlang...",
  TITTLE_NO_OPTIONS_PLACEHOLDER: "Malumotlar yoq...",
  TITTLE_REQUIRED: "Maydon toldirilishi shart!",
  TITLE_ACTION_TABLE: "Harakatlar",

  //Home
  TITTLE_HOME_LIST_OF_ORDERS: "Buyurtmalar ro'yhati",
  TITTLE_ORDERS_CREATE_ORDER_MODAL_HEADER: "Yangi zakaz yaratish",
  TITTLE_ORDER_MODAL_CLIENT: "Mijoz",
  TITTLE_ORDER_MODAL_COMPANY: "Etkazib beruvchi tashkilot",
  TITTLE_ORDER_MODAL_NAME_SENDER: "Jo'natuvchini ismi",
  TITTLE_ORDER_MODAL_NAME_RECEIVER: "Qabul qiluvchini ismi",

  //Buttons
  TITTLE_BTN_ADD: "Qo'shish",
  TITTLE_ADD_ZONE: "Zona qo'shish",
  TITTLE_ADD_OBJECT: "Obyekt qo'shish",
  TITTLE_ZONE: "Zonalar",
  TITTLE_LOCATION_OBJECT: "Obyektlar joylashuvi",
  TITTLE_ROUTES_PAGE_CREATE_ROUTES_BTN: "Marshrut yaratish",
  TITTLE_ROUTES_PAGE_SPEND: "Провести",
  TITTLE_RELOAD_DATA_FILTER: "Malumotlani yangilash",
  TITTLE_FULLSCREEN_FILTER: "Butun oynada ochish",
  TITTLE_DOWNLOAD_FILTER: "Yuklab olish",
  TITTLE_PRINT_FILTER: "Chiqarish",
  TITLE_ACCEPT_BTN: "Tasdiqlash",
  TITLE_CANCEL_BTN: "Yopish",

  //Routes
  TITTLE_ROUTES_PAGE_ROUTES: "Marshrutlar",
  TITTLE_ROUTES_PAGE_SHOW_ALL: "Barchasi",
  TITTLE_ROUTES_PAGE_SHOW_UNALLOCATED: "Ajratilmaganlar",
  TITTLE_ROUTES_PAGE_RESET_ALL: "Barchasini tiklash",

  //Routes Setting
  TITTLE_ROUTES_SETTING_SWITCH_MAP: "Xarita",
  TITTLE_ROUTES_SETTING_SWITCH_TARRIFS: "Tariflar",
  TITTLE_ROUTES_SETTING_SWITCH_TIME_OF_ROUTES: "Marshrut vaqti",
  TITTLE_ROUTES_SETTING_SWITCH_TIME_OF_DELIVERY: "Yetkazib berish",
  TITTLE_ROUTES_SETTING_SWITCH_SETTING: "Qurish parametrlari",

  //Login
  TITTLE_LOGIN_WELCOME_BACK: "Qaytib kelganingizdan xursandmiz !",
  TITTLE_LOGIN_SIGN_IN_TO: "Davom etish uchun Sello logistics tizimiga kiring",
  TITTLE_LOGIN_EMAIL: "Telefon raqam",
  TITTLE_LOGIN_FORGET_PASSWORD: "Parolni unutdingizmi ?",
  TITTLE_LOGIN_PASSWORD: "Parol",
  TITTLE_LOGIN_REMEMBER_ME: "Eslab qolish",
  TITTLE_LOGIN_SIGN_IN: "Kirish",
  TITTLE_LOGIN_DONT_HAVE_ACCOUNT: "Sizda akkaunt yomi ?",
  TITTLE_LOGIN_SIGN_UP: "Ro'yhatdan o'tish",
  TITTLE_LOGIN_FOOTER: "Sello Logistics. Crafted with",
  TITTLE_LOGIN_FOOTER2: "by Tune Consulting",

  //Forget Password
  TITTLE_FORGOT_PASSWORD_ENTER_EMAIL:
    "Elektron pochta manzilingizni kiriting va ko'rsatmalar sizga yuboriladi!",
  TITTLE_FORGOT_PASSWORD_MAIN: "Parolni unutdingizmi ?",
  TITTLE_FORGOT_PASSWORD_SEND_RESET: "Qayta tiklash havolasini yuboring",
  TITTLE_FORGOT_PASSWORD_I_REMEMBER: "Toxtang, men parolimni esladim ...",
  TITTLE_FORGOT_CLICK_HERE: "Buyerga bosing",
  TITTLE_FORGOT_RESET_PASSWORD_WITH: "Sello Logistics-da parolni tiklash",

  //DRIVER
  TITTLE_EDIT_MODAL_DRIVER: "Xaydovchini tahrirlash",
  TITTLE_ADD_MODAL_DRIVER: "Xaydovchini qo'shish",
  TITTLE_PRODUCER_MODAL_DRIVER: "Ishlab chiqaruvchi",
  TITTLE_MODEL_MODAL_DRIVER: "Modeli",
  TITTLE_TYPE_OF_CAR_MODAL_DRIVER: "Turi",
  TITTLE_TYPE_MODAL_DRIVER: "Kuzovi",
  TITTLE_COLOR_MODAL_DRIVER: "Rangi",
  TITTLE_REGISTER_YEAR_MODAL_DRIVER: "Ishlab chiqarilgan yili",
  TITTLE_LICENSE_PLATE_MODAL_DRIVER: "Raqami",
  TITTLE_STATUS_MODAL_DRIVER: "Statusi",
  TITTLE_COURIER_COMPANY_MODAL_DRIVER: "Kuryer kompaniyasi",
  TITTLE_DRIVER_MODAL_DRIVER: "Haydovchi",
  TITTLE_CAR_LENGTH_DRIVER: "Uzinligi kg",
  TITTLE_CAR_WIDTH_DRIVER: "Kengligi kg",
  TITTLE_CAR_HEIGHT_DRIVER: "Balandligi kg",

  //NAVBAR
  TITTLE_NAVBAR_MENU_MONITORING: "Monitoring",
  TITTLE_NAVBAR_MENU_PRODUCTS: "Mahsulotlar",
  TITTLE_NAVBAR_MENU_SHIPMENT: "Jonatish",
  TITTLE_NAVBAR_MENU_STAFF: "Hodimlar",
  TITTLE_NAVBAR_MENU_SETTINGS: "Sozlamalar",
  TITTLE_NAVBAR_MENU_MONITORING_ORDERS: "Заказы",
  TITTLE_NAVBAR_MENU_MONITORING_REMAINS: "Остатки Рц",
  TITTLE_NAVBAR_MENU_MONITORING_HISTORY_CASHBOX: "История касса",
  TITTLE_NAVBAR_MENU_MONITORING_LOAD_ORDERS: "Нагрузка по заказам",
  TITTLE_NAVBAR_MENU_PRODUCTS_ACCEPTANCE: "Приемка",
  TITTLE_NAVBAR_MENU_PRODUCTS_MARKING: "Маркировка",
  TITTLE_NAVBAR_MENU_PRODUCTS_TRAFFIC: "Движение",
  TITTLE_NAVBAR_MENU_PRODUCTS_EQUIPMENT: "Комплектация",
  TITTLE_NAVBAR_MENU_PRODUCTS_STORAGE: "Хранение",
  TITTLE_NAVBAR_MENU_PRODUCTS_ZONES: "Зоны",
  TITTLE_NAVBAR_MENU_PRODUCTS_MOVEMENT: "Перемещение",
  TITTLE_NAVBAR_MENU_PRODUCTS_INVENTORY: "Инвентаризация",
  TITTLE_NAVBAR_MENU_PRODUCTS_PRODUCT_CARDS: "Карточки товаров",
  TITTLE_NAVBAR_MENU_STAFF_SHIFTS: "Смены",
  TITTLE_NAVBAR_MENU_STAFF_PERMISSIONS: "Доступы",
  TITTLE_NAVBAR_MENU_SHIPMENT_CASHBOX: "Касса",
  TITTLE_NAVBAR_MENU_SHIPMENT_ISSUE_CLIENT: "Выдача клиенту",
  TITTLE_NAVBAR_MENU_SHIPMENT_RETURN: "Возврат",
  TITTLE_NAVBAR_MENU_SETTINGS_ADDRESS_STORAGE: "Адресное хранение",
  TITTLE_NAVBAR_MENU_SETTINGS_SETTING_RC: "Параметры РЦ",
  TITTLE_NAVBAR_MENU_SETTINGS_EMPLOYEES: "Сотрудники",

  //PRODUCTS
  TITTLE_PRODUCTS_ACCEPTANCE_OUTFITS_FOR_ARRIVAL: "Наряда к приходу",
  TITTLE_PRODUCTS_ACCEPTANCE_OUTFITS_FOR_SHIPMENT: "Наряда к уходу",
  TITTLE_PRODUCTS_ACCEPTANCE_GOODS_TO_ARRIVAL: "Товары к приходу",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_ARRIVAL: "Arrival",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SUPPLIER: "Supplier",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_AGREEMENT: "Agreement",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_PERFORMING_COMPANY: "Performing product",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_VEHICLE: "Vehicle",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_HAND_OVER: "Hand over",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_ACCEPTED: "Accepted",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SEND_TO_1C: "1С jonatish",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_PRINT: "Print",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SAVE: "Saqlash",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SCAN_YK_PRODUCTS: "Scan YK products",
};
